export enum UserGroupTab {
  User = 'user',
  Group = 'group',
}
